// extracted by mini-css-extract-plugin
export var htmlPreview = "_oc-2";
export var modal = "_oc-0";
export var sidebar = "_oc-1";